import { User } from '@/modules/User/interfaces/user'
import { File } from '@/modules/File/interfaces/file'
import { Account } from './account'
import { VehicleOwnership, VehicleUseage } from '@/modules/Vehicle/interfaces/vehicle'

export enum AccountAssetType {
  PROPERTY = 'PROPERTY',
  VEHICLE = 'VEHICLE',
}

export interface AssetProperty {
  id: number;
  asset: AccountAsset;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
  propertyType: string;
  owner: string;
  price: string;
  propertyStatus: string;
  creationTime: string;
  buyTime: string;
  createdAt: string;
  updatedAt: string;
}

export interface AssetVehicle {
  id: number;
  asset: AccountAsset;
  vid: string;
  owner: string;
  brand: string;
  color: string;
  type: string;
  price: string;
  createdAt: string;
  updatedAt: string;
  ownership: VehicleOwnership
  mileage: string
  useage: VehicleUseage
}

export interface AccountAsset {
  id: number;
  name: string;
  notes: string;
  type: AccountAssetType
  accountId: string;
  property: AssetProperty
  vehicle: AssetVehicle
  createdAt: string;
  updatedAt: string;
  account: Account;
  createdBy: User;
  lastModifiedBy: User;
  files: File[];
}
